<!-- 工程师列表 -->
<template>
  <div>
    <RadioTable
      v-if="options.length > 0"
      v-model="val"
      radioLabel="#"
      :loading="loading"
      :height="230"
      radioKey="id"
      :columns="columns"
      :tableData="options"
      @change="handleChange"
    ></RadioTable>

    <AddDialog v-if="canAdd" @success="handleSuccess" />
  </div>
</template>

<script>
import RadioTable from '@@/components/radioTable/index'
import AddDialog from './addDialog'

export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    canAdd: {
      type: Boolean,
      default: true
    },
    length: {
      type: Number,
      default: 0
    }
    // radioKey: {
    //   type: String,
    //   default: 'id'
    // }
  },
  components: {
    RadioTable,
    AddDialog
  },
  data() {
    return {
      loading: false,
      val: this.value,
      columns: [
        { label: '姓名', prop: 'name', width: 100 },
        { label: '手机/电话', prop: 'tel', width: 120 },
        { label: 'E-mail', prop: 'email', width: 180 }
      ],
      options: [],
      optionsLength: 0
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    length(newVal) {
      this.optionsLength = newVal
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
    },
    handleChange(item) {
      this.val = item.id || ''
      this.handleEmit()
      this.$emit('change', item)
    },
    getList() {
      this.loading = true
      this.$store.dispatch('orderEngineer/getEngineerList', this.optionsLength !== this.options.length)
        .then(res => {
          this.options = res
          this.handleLengthChange(res.length)
          this.selectDefault()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 已选的 > 默认的 > 第一个
    selectDefault() {
      const { val, options } = this
      if (options && options.length > 0) {
        const item = options.find(i => (!!val > 0 ? i.id === val : i.isDef == 1))
        this.handleChange(item || options[0])
      } else {
        this.handleChange({})
      }
    },
    handleSuccess(id) {
      this.val = id
      this.handleLengthChange(this.optionsLength + 1)
      this.getList()
      this.$nextTick(() => {
        this.$emit('addSuccess')
      })
    },
    handleLengthChange(length) {
      this.optionsLength = length
      this.$emit('update:length', length)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>